import { type QueryClient } from '@tanstack/react-query'
import { ReadWorkflowsV2 } from '../../util/operationIds'
import { refreshCachedEntityDocuments } from '../../util/refreshCachedEntityDocuments'
import { replaceMomentWorkflows } from './cacheTransformFns/replaceMomentWorkflows'
import {
  readMomentWorkflows,
  type MomentWorkflowsDocument,
} from './readMomentWorkflows'

/**
 * Re-reads a moment’s workflows into every cached workflows document that covers it. Short-circuits if there are no
 * queries to run. If the read fails, the documents are invalidated instead of the promise failing.
 */
export const refreshMomentWorkflows = (
  queryClient: QueryClient,
  legacyMomentId: number
) =>
  refreshCachedEntityDocuments<MomentWorkflowsDocument>({
    entityId: legacyMomentId,
    filterName: 'context.moment_id',
    operationId: ReadWorkflowsV2,
    queryClient,
    read: () => readMomentWorkflows([legacyMomentId]),
    replace: (incoming) => replaceMomentWorkflows([legacyMomentId], incoming),
    resourceKey: 'workflow',
  })
